<div class="form-input">
  <label class="form-label">{{formData?.label || 'Label'}}</label>
  <form class="m-0 p-0" (ngSubmit)="addToList()" >
    <input [attr.data-test]="formCtrlName" [(ngModel)]="inputValue" name="input" [type]="formData?.type || 'text'" class="form-control" [placeholder]="formData?.placeholder || 'Enter Value'">
    <div class="mt-1" *ngIf="inputValue.length">
      <small class="text-info">Hint: Press <strong>Enter</strong> to add value</small>
    </div>
  </form>
  <p class="caption-msg text-f12 mt-1" *ngIf="caption">
    <fa-icon [icon]="icons.info"></fa-icon>
    <span class="ms-2">{{caption}}</span>
  </p>
  <ng-container *ngIf="lists">
    <div data-test="list-group" class="mt-3" >
      <span class="badge rounded-pill badge-sec me-3 mb-2" *ngFor="let item of lists; let i = index">
        <span [attr.data-test]="item" class="me-2">{{item}}</span>
        <span (click)="removeFromList(i, item)" class="cur-pnt delete-icon"><fa-icon [icon]="icons.times"></fa-icon></span>
      </span>
    </div>
  </ng-container>
</div>
